import { useState } from 'react';
// import ModalComponent from '@components/Modal/ModalComponent';
import AddUpdateDriver from './AddUpdateDriver';
import { Card, CardBody } from '@components/card/card';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useTranslation } from 'react-i18next';

// import useGetPeoplesList from '@hooks/NTX/useGetPeoplesList';
import NtxTable from '@components/DataTable/NtxTable';
import Loading from '@components/Shared/Loader/Loading';
// import EditDrivers from './EditDrivers';
import NeatixModal from '@components/Modal/NeatixModal';
import useGetDriversList from '@hooks/FLeet/useGetDriversList';
import { usePermissions } from '@Helper/Permisstions/usePermissions';

const Index = () => {
  const { HasPermission } = usePermissions();
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [Id, setId] = useState('');
  const { t, i18n } = useTranslation();
  // const { DriversList, loading } = useGetPeoplesList({ LookupType: '' });

  const { OptionsDrivers, loading, error } = useGetDriversList();

  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('Person No'), key: 'personNo' },
    { title: i18n.language === 'en' ? 'Assigned Vehicle' : 'مخصص له مركبة', key: 'hasVehicle' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = OptionsDrivers?.map(item => {
    let rowClass;

    return {
      Name: item.label,
      personNo: item.personNo,
      hasVehicle: item.hasVehicle ? (
        <span className='badge bg-success'>{t('Yes')}</span>
      ) : (
        <span className='badge bg-secondary'>{t('No')}</span>
      ),
      action: (
        <button
          hidden={!HasPermission('FleetViewDriverDetails')}
          type='button'
          className='btn btn-sm btn-outline-theme'
          onClick={() => {
            setId(item.value);
            setShow2(true);
          }}
        >
          <i className='far fa-lg fa-fw me-2 fa-edit'></i>
          {t('Button.Edit')}
        </button>
      ),

      rowClass // استخدم rowClass هنا
    };
  });
  //________________________________

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
             link: ':moduleHome'
            },
            {
              name: 'Drivers',
              link: null
            }
          ]}
          PageName='Drivers'
        />
        <div className='ms-auto'>
          <a
            hidden={!HasPermission('FleetAddDriver')}
            href='#/'
            className='btn me-1 btn-theme'
            data-bs-toggle='modal'
            data-bs-target='#modalAddDrivers'
            onClick={() => setShow(true)}
          >
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            {t('AddDrivers')}
          </a>
        </div>
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
             
            />
          </CardBody>
        </Loading>
      </Card>

      <NeatixModal setShow={setShow} show={show} size='lg' title={t('AddDrivers')}>
        {<AddUpdateDriver Id={Id} isUpdate={false} onClose={() => setShow(false)} />}
      </NeatixModal>
      <NeatixModal setShow={setShow2} show={show2} size='lg' title={t('EditDrivers')}>
        {<AddUpdateDriver Id={Id} isUpdate={true} onClose={() => setShow2(false)} />}
      </NeatixModal>
    </>
  );
};

export default Index;
//  {/* <ModalComponent title={t('AddDrivers')} id='modalAddDrivers' size='lg'>
//       {show && <AddUpdateDriver Id={null} />}
//     </ModalComponent>
//     <ModalComponent title={t('EditDrivers')} id='modalEditDrivers' size='lg'>
//       {show && <AddUpdateDriver Id={Id} isUpdate />}
//      </ModalComponent> */}
